import * as React from 'react';

import { getTranslation, keys } from '../../../Resources/Translations';
import { BrandListPageViewModel } from './BrandListPageViewModel.csharp';

export const BrandListPage = (props: BrandListPageViewModel) => {
    const initialOffset = 30;
    const navRef = React.useRef<HTMLUListElement>(null);
    const [offsetTop, setOffsetTop] = React.useState(initialOffset);

    React.useEffect(() => {
        window?.addEventListener('resize', adjustOffset);

        return () => {
            window?.removeEventListener('resize', adjustOffset);
        };
    }, []);

    React.useEffect(() => {
        adjustOffset();
    }, [navRef]);

    const adjustOffset = () => {
        if (navRef.current) {
            setOffsetTop(navRef.current.offsetHeight - initialOffset);
        }
    };

    return (
        <>
            <h2 className="BrandListPage__Ingress">{getTranslation(keys['brand.brands'])}</h2>

            <ul className="BrandListPage__ContainersNav" ref={navRef}>
                {props.brandContainers.map((brandContainer, i) => (
                    <li key={i} className="BrandListPage__ContainersNavEl">
                        <a href={'#' + brandContainer.title}>{brandContainer.title}</a>
                    </li>
                ))}
            </ul>

            <div className="BrandListPage__Containers">
                {props.brandContainers.map((brandContainer, i) => (
                    <div key={i}>
                        <h3 className="BrandListPage__ContainerTitle" id={brandContainer.title} style={{ scrollMarginTop: offsetTop }}>
                            {brandContainer.title}
                        </h3>
                        <ul className="BrandListPage__Container">
                            {brandContainer.brands.map((brand, i) => (
                                <li key={i} className="BrandListPage__ContainerEl">
                                    <a target={brand.target} href={brand.href}>
                                        <span>{brand.text}</span>
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>
        </>
    );
};
